var map = {
	"./icons_action.png": 1689,
	"./icons_action_desktop.png": 728,
	"./icons_activityLevel_0.png": 5785,
	"./icons_activityLevel_1.png": 3680,
	"./icons_activityLevel_2.png": 5435,
	"./icons_activityLevel_3.png": 1778,
	"./icons_activityLevel_4.png": 4573,
	"./icons_airExchangeRate_0.png": 1667,
	"./icons_airExchangeRate_1.png": 6458,
	"./icons_airExchangeRate_2.png": 7041,
	"./icons_airExchangeRate_3.png": 5912,
	"./icons_airExchangeRate_4.png": 8551,
	"./icons_all_0.png": 643,
	"./icons_all_1.png": 5434,
	"./icons_all_2.png": 4417,
	"./icons_all_3.png": 6152,
	"./icons_arrow.png": 1356,
	"./icons_arrow_down_1.png": 4425,
	"./icons_criticalDose_0.png": 9470,
	"./icons_criticalDose_1.png": 8967,
	"./icons_emitterType_0.png": 4588,
	"./icons_emitterType_1.png": 6853,
	"./icons_emitterType_2.png": 4750,
	"./icons_emitterType_3.png": 7239,
	"./icons_maskEfficiencyExhaled_0.png": 4066,
	"./icons_maskEfficiencyExhaled_1.png": 5195,
	"./icons_maskEfficiencyExhaled_2.png": 5344,
	"./icons_maskEfficiencyExhaled_3.png": 2249,
	"./icons_maskEfficiencyExhaled_4.png": 9174,
	"./icons_maskEfficiencyInhaled_0.png": 1408,
	"./icons_maskEfficiencyInhaled_1.png": 7161,
	"./icons_maskEfficiencyInhaled_2.png": 3154,
	"./icons_maskEfficiencyInhaled_3.png": 6811,
	"./icons_maskEfficiencyInhaled_4.png": 4820,
	"./icons_person_0.png": 1065,
	"./icons_person_1.png": 4160,
	"./icons_roomVolume_0.png": 7457,
	"./icons_roomVolume_1.png": 7240,
	"./icons_roomVolume_2.png": 451,
	"./icons_roomVolume_3.png": 6346,
	"./icons_roomVolume_4.png": 117,
	"./icons_szenario_doctor.png": 3656,
	"./icons_szenario_party.png": 9965,
	"./icons_szenario_school.png": 5125,
	"./icons_teaser.png": 1539,
	"./icons_timeInRoom_0.png": 7333,
	"./icons_timeInRoom_1.png": 796,
	"./icons_timeInRoom_2.png": 9271,
	"./icons_timeInRoom_3.png": 1582,
	"./icons_timeInRoom_4.png": 7697,
	"./icons_voiceStrengths_0.png": 4538,
	"./icons_voiceStrengths_1.png": 8643,
	"./icons_voiceStrengths_2.png": 5432,
	"./icons_voiceStrengths_3.png": 5649,
	"./icons_voiceStrengths_4.png": 2558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1050;